module.exports = __webpack_public_path__ + "static/media/logo.58a933d6.png";